import axios from 'axios';

const API = axios.create({
  baseURL: import.meta.env.VITE_INVESTMENTS_API_URL || 'http://localhost:5001',
  headers: { 'Content-Type': 'application/json' },
  timeout: 10000,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export async function listStatements() {
  const { data } = await API.get('/api/statements/me');
  return data?.data || [];
}

export async function getStatement(period, { refresh = false } = {}) {
  // La PRIMERA generacion de un extracto es pesada: agrega movimientos, escribe
  // el insight del Oraculo (Claude) y genera el audio con voz Daniela (ElevenLabs
  // + S3) de forma sincrona -> puede tardar ~30-60s. Timeout amplio solo aqui.
  const { data } = await API.get(`/api/statements/me/${period}`, {
    params: refresh ? { refresh: 1 } : {},
    timeout: 90000,
  });
  return data?.data || null;
}

export async function downloadStatementPdf(period) {
  const res = await API.get(`/api/statements/me/${period}/pdf`, {
    responseType: 'blob',
    timeout: 30000,
  });
  const blob = new Blob([res.data], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `FlowexPay_Extracto_${period}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Envia el audio del extracto (voz del Oraculo) al WhatsApp del cliente.
export async function sendStatementWhatsapp(period, phone) {
  const { data } = await API.post(`/api/statements/me/${period}/whatsapp`, { phone }, { timeout: 40000 });
  return data;
}

export function formatPeriodLabel(period) {
  const months = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
  const [y, m] = period.split('-');
  const idx = parseInt(m, 10) - 1;
  return `${months[idx]} ${y}`;
}

export function formatUsd(n) {
  const num = Number(n || 0);
  return `$${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
